// extracted by mini-css-extract-plugin
export default {"pageLayout":"R-z","mainContent":"S-z","activeSidebar":"T-z","columnLayout":"U-z","columnLayoutFill":"V-z","columnLayoutLast":"W-z"};